/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CurrencyChainResponse } from './currency-chain-response';


export interface CurrencyResponse { 
    id: number;
    ticker: string;
    name: string;
    minWithdrawalAmount: number;
    precision: number;
    isSwapEnabled: boolean;
    chains: Array<CurrencyChainResponse>;
}

